/*=============================================== HelmetPage ===============================================*/

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

const HelmetPage = () => {
    const items: ItemType[] = [
        {
            code: '<Helmet title="Page title" favicon="/favicon.svg" />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "title",
            type: "string",
            required: true,
        },
        {
            subtitle: "favicon",
            type: "string",
        },
        {
            subtitle: "description",
            type: "string",
        },
        {
            subtitle: "keywords",
            type: "string or array of strings",
        },
        {
            subtitle: "author",
            type: "string",
        },
        {
            subtitle: "type",
            type: "string",
        },
        {
            subtitle: "cover",
            type: "string",
        },
        {
            subtitle: "siteName",
            type: "string",
        },
        {
            subtitle: "language",
            type: "string",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default HelmetPage
